// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"132":"0f174f68","193":"28868dae","210":"da96edc0","221":"01657e3c","232":"e39a5ec7","274":"76bb831c","293":"28355116","357":"0bbf0c58","358":"97efe51f","410":"d06c852f","534":"b217747d","660":"42cd4037","713":"67ad6891","789":"6277266a","975":"b23c3081"}[chunkId] + ".chunk.js";
};